module.exports = __webpack_public_path__ + "img/picture_03@2x.9ea3c10c.png";